import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash'
import { Formik, Form, Field } from 'formik';
import { Label, Image, Popup, Dropdown, Modal, Button } from 'semantic-ui-react';
import JsonStoryEditor from '../../components/jsonEditor/jsonEditor';
import FillVariations from './FillVariations';
import versionIcon from '../../assets/version_icon_simple.svg';
import {
  CustomDropdown,
  fetchAllBooks,
  fetchFullBookDataSet,
  fetchparseDataFromS3, selectParsedStoryData,
  // getBookTreeElement,
  resetParsedStoryData,
  selectBookListOptions,
  selectEditedStoryJson,
  selectFullBookDataSet
} from '../../slices/storyEditorSlice';

import { AuthStdFooter } from "../../utils/auth-std-footer";
const AIFileEditor = () => {
  const dispatch = useDispatch();
  const userProfile = useSelector(state => state.user.profile);
  const bookListOptions = useSelector(selectBookListOptions);
  const parsedStoryDataFetched = useSelector(selectParsedStoryData);
  const fullBookDataSet = useSelector(selectFullBookDataSet);
  const activeEditedJson = useSelector(selectEditedStoryJson)

  const [activeParsedItem, setActiveParsedItem] = useState(null);
  const [parsedStoryData, setParsedStoryData] = useState([]);
  // const [hasProcessedVersionItems, setHasProcessedVersionItems] = useState([]);
  const [bookSelection, setBookSelection] = useState(null);
  const [bookUuid, setBookUuid] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [artListDropdownOpen, setArtListDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [saveAction, setSaveAction] = useState(null);
  const [enabledSave, setEnabledSave] = useState(false);

  const handleBookDDOpen = () => { setArtListDropdownOpen(true); };
  const handleBookDDClose = () => { setArtListDropdownOpen(false); };


  const refreshFetch = useCallback(() => {
    dispatch(fetchAllBooks({ userId: userProfile.data.userId, reqCategories: "" }))
      .unwrap()
      .then(data => {
        console.log('fetchAllBook in refreshFetch');
      })
      .catch(error => {
        // handle error here
      });
  }, [dispatch, userProfile.data.userId]);

  useEffect(() => {
    refreshFetch();
  }, [refreshFetch]);

  useEffect(() => {
    if (bookSelection !== null && bookSelection.data !== undefined) {
      if (bookSelection && bookSelection.data.uuid) {
        setBookUuid(bookSelection.data.uuid);
        dispatch(fetchFullBookDataSet({ userId: userProfile.data.userId, bookUuid: bookSelection.data.uuid })).unwrap();
      }
    }
  }, [bookSelection, userProfile.data.userId, dispatch]);

  useEffect(() => {
    console.log('fullBookDataSet', fullBookDataSet)
    setParsedStoryData(fullBookDataSet.processedVersionItems);


  }, [fullBookDataSet]);

  const onVersionHandler = (item) => {
    setIsPopupOpen(false);
    dispatch(resetParsedStoryData());
    let jsonFile = `${item.fileName}.txt`;
    setActiveParsedItem(item);
    console.log('onVersionHandler', item, 'selectedBook', bookSelection, "jsonFile", jsonFile);
    // dispatch(fetchparseDataFromS3({ userId: userProfile.data.userId, targetUrl: `123e4567-e89b-12d3-a456-426614174008/book-process-items/${jsonFile}` }));
    console.log('onVersionHandler bookUuid', bookUuid);

    dispatch(fetchparseDataFromS3({ userId: userProfile.data.userId, targetUrl: `${bookUuid}/book-process-items/${jsonFile}` }));

    setEnabledSave(false)
  };

  const handleSelectedBook = (bookData) => {
    console.log('handleSelectedBook', bookData)
    setBookSelection(bookData);
  };

  const handleSaveAction = (action) => {
    setSaveAction(action);
    setIsModalOpen(true);
  };

  const confirmSaveAction = () => {
    setIsModalOpen(false);
    console.log('confirmSaveAction item', activeParsedItem, 'json', activeEditedJson);

    if (saveAction === 'update') {
      console.log('Updating the current version', activeParsedItem);
      console.log('Updating activeEditedJson', activeEditedJson)
    } else if (saveAction === 'newVersion') {
      console.log('Creating a new version', activeParsedItem);
      console.log('Creating activeEditedJson', activeEditedJson)

    }
  };
  const handleSaveStatus = (allowSave) => {
    setEnabledSave(allowSave);
  }
  function getNextVersion(fileName, dataArray) {
    const matchingFiles = dataArray.filter(item => item.fileName === fileName);
    const versionNumbers = matchingFiles.map(item => parseInt(item.version, 10));
    const maxVersion = Math.max(...versionNumbers);
    const nextVersion = maxVersion + 1;

    return nextVersion.toString();
  }
  const renderActiveItem = (update) => {
    if (activeParsedItem === null || _.isEmpty(activeParsedItem) || parsedStoryData === null) return (<div style={{ marginBottom: "70px" }}>No Active Parsed file found</div>)
    console.log('renderActiveItem parsedStoryData', parsedStoryData)
    let displayObj = {
      fileName: activeParsedItem.fileName,
      thumbnail: activeParsedItem.thumbnail,
      uuid: activeParsedItem.uuid,
      version: activeParsedItem.version,
    };
    if (!update) {
      let nextVersionNumber = getNextVersion(displayObj.fileName, parsedStoryData);
      displayObj.uuid = uuidv4();
      displayObj.version = nextVersionNumber.toString();
    }
    return (
      <dl className="inline-dl">
        {Object.entries(displayObj).map(([key, value]) => (
          <React.Fragment key={key}>
            <dt>{key}</dt>
            <dd>{value}</dd>
          </React.Fragment>
        ))}
      </dl>
    );
  };
  const saveOptions = [
    { key: 'update', text: 'Update', value: 'update' },
    { key: 'newVersion', text: 'New Version', value: 'newVersion' },
  ];

  return (
    <>
      <div className="listTitle">AI File Editor</div>
      <div style={{ maxWidth: "1100px" }}>
        <Formik
          initialValues={{ selectedStory: '' }}
          onSubmit={(values) => console.log(values)}
        >
          {() => (
            <Form>

              <div className='story-selector-container'>
                <div className='story-selector-book-container'>
                  <Popup
                    disabled={bookSelection === null}
                    position={"top right"}
                    on="click"
                    open={isPopupOpen}
                    onOpen={() => setIsPopupOpen(true)}
                    onClose={() => setIsPopupOpen(false)}
                    popper={{ id: 'popper-container', style: { zIndex: 2000 } }}
                    content={
                      <div className='story-version-container'>
                        <div style={{ color: "#000000" }}>
                          <FillVariations isOpen={isPopupOpen} onVariationClick={onVersionHandler} />
                        </div>
                      </div>
                    }
                    trigger={
                      <Button basic className="version-button" disabled={bookSelection === null} type={'button'}>
                        <div className="button-content">
                          <span>Versions</span>
                          <Image src={versionIcon} className='story-version-img' />
                        </div>
                      </Button>
                    }
                  />
                </div>
                <div className='story-selector-group-container'>
                  <Label className='form-label' >Story</Label>
                  <Field
                    name="selectedStory"
                    component={CustomDropdown}
                    options={bookListOptions}
                    className={artListDropdownOpen ? 'no-radius-dropdown-open' : 'no-radius-dropdown'}
                    onOpen={handleBookDDOpen}
                    onClose={handleBookDDClose}
                    onSelectedBook={handleSelectedBook}
                    placeholder='Stories'
                    selection
                    style={{ zIndex: "10000", marginLeft: '10px' }}
                  />
                </div>
                <Dropdown
                  disabled={!enabledSave}
                  placeholder="Save/Update"
                  defaultValue="Save/Update"
                  selection
                  options={saveOptions}
                  onChange={(e, { value }) => handleSaveAction(value)}
                  className={enabledSave ? 'save-update-dropdown' : 'save-update-dropdown-disable'}
                />
              </div>
            </Form>

          )}
        </Formik>
      </div>
      <div className='story-json-editor-container'>
        <JsonStoryEditor storyJsonData={parsedStoryDataFetched} uuid={bookUuid ? bookUuid : ''} onUpdate={handleSaveStatus} />
      </div>
      <Modal size={"tiny"} open={isModalOpen} onClose={() => setIsModalOpen(false)} >
        <Modal.Header>Confirm {saveAction === 'update' ? 'Update' : 'New Version'}</Modal.Header>
        <Modal.Content>
          <>
            <p className="modalContentHeading">Are you sure you want to {saveAction === 'update' ? `update the current version:` : 'create a new version'}?</p>
            {saveAction !== null && saveAction === 'update' ? renderActiveItem(true) : renderActiveItem(false)}
          </>
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => setIsModalOpen(false)}>No</Button>
          <Button positive onClick={confirmSaveAction}>Yes</Button>
        </Modal.Actions>
      </Modal>
      {AuthStdFooter()}

    </>
  );
};

export default AIFileEditor;
